import { AuthService } from './../../shared/service/auth.service';
import { MsgService } from './../../shared/service/msg.service';
import {Component, inject, OnInit} from '@angular/core';
import {Usuario} from '../../shared/model/usuario/usuario.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UsuarioService} from '../../shared/service/usuario.service';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {SlideTogglePadraoComponent} from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {IdNome} from '../../shared/model/id-nome.model';
import {SelectOneComponent} from '../../shared/components/select-one/select-one.component';
import {PerfilService} from '../../shared/service/perfil.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {environment} from '../../../../environments/environment';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MethodsUtils } from '../../shared/util/methods.utils';
import { NgStyle } from '@angular/common';
import {MatOption} from '@angular/material/core';
import { SetorService } from '../../shared/service/setor.service';

@Component({
  selector: 'app-modal-cadastro-visualizacao-usuario',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SlideTogglePadraoComponent,
    FormFieldComponent,
    SelectOneComponent,
    ReactiveFormsModule,
    NgStyle,
    MatOption
  ],
  templateUrl: './modal-cadastro-visualizacao-usuario.component.html',
  styleUrl: './modal-cadastro-visualizacao-usuario.component.css'
})
export class ModalCadastroVisualizacaoUsuarioComponent implements OnInit {
  visualizar = false;
  usuario: Usuario = new Usuario();
  usuarios: Usuario[] = [];
  perfis: IdNome[] = [];
  setores: IdNome[] = [];
  imgUsuario?: SafeUrl;
  isUsuarioAd = false
  buscouAd = false

  isCadastro = false;
  formUsuario!: FormGroup;
  salvando: boolean = false;

  usuarioLogado: Usuario = new Usuario();
  editarOperador = false;

  private readonly dialog = inject<MatDialogRef<ModalCadastroVisualizacaoUsuarioComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);
  private readonly usuarioService = inject(UsuarioService);
  private readonly perfilService = inject(PerfilService);
  private readonly setorService = inject(SetorService);
  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly msgService = inject(MsgService);
  private readonly fb = inject(FormBuilder);

  ngOnInit() {
    this.formUsuario = this.fb.group({
      email: ['', [Validators.required, Validators.minLength(3), Validators.email]],
      nome: ['', [Validators.required, Validators.minLength(3)]],
      perfil: [null, [Validators.required]],
      setor: [null, [Validators.required]],
      telefone: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      cpf: ['', [Validators.required, MethodsUtils.validarCPFControl()]],
    });
    this.usuarioLogado = this.authService.getUsuarioLogado();
    this.visualizar = this.data['visualizar'];
    const usuarioId = this.data['usuarioId'];
    this.buscarPerfis();
    this.buscarSetores();
    if (usuarioId) {
      this.buscarUsuarioCompleto(usuarioId);
      this.isCadastro = false
      this.buscouAd = true
    } else {
      this.isCadastro = true
      this.configurarUsuarioFormBuilder()
    }
    this.alteracaoService.camposNaoAlterados();
  }

  buscarUsuarioCompleto(usuarioId: number) {
    this.usuarioService.buscarUsuarioComplete(usuarioId).subscribe({
      next: res => {
        this.usuario = res
        this.editarOperador = !!(this.usuario && this.usuario.isOperador);
        if (this.usuario.ldapHabilitado) { this.isUsuarioAd = true; }
        this.configurarUsuarioFormBuilder()
      }
    });
  }

  salvarForm(){
    if (this.buscouAd) {
      this.salvar()
    } else {
      this.buscarAd()
    }
  }

  buscarAd(){
    const formEmail = this.formUsuario.value.email;
    if (formEmail != undefined && formEmail.length > 3) {
      this.usuarioService.buscarUsuarioAdPorEmail(formEmail).subscribe({
        next: res => {
          if (res.length === 1 && res[0].id) {
            this.msgService.msgAdvertencia("Já existe um usuário cadastrado com o email informado. Por favor, verifique o email e tente novamente.");
          } else {
            if (res.length >= 1) {
              this.usuarios = res;
              this.isUsuarioAd = true;
              this.buscouAd = true;
            } else {
              this.msgService.msgInfo("Não foi encontrado nenhum usuário no AD com o email informado.");
              this.buscouAd = true;
            }
          }
        },
        complete: () => this.atualizarCamposDesabilitados()
      });
    } else {
      const emailControl = this.formUsuario.get('email');
      emailControl?.setErrors({ 'email': true });
    }
  }

  disabledEmail():boolean { return !this.isCadastro || this.isUsuarioAd || this.buscouAd; }
  disabledNome():boolean { return this.isUsuarioAd; }

  atualizarCamposDesabilitados(): void {
    const emailControl = this.formUsuario.get('email');
    const nomeControl = this.formUsuario.get('nome');
    const cpfControl = this.formUsuario.get('cpf');
    const perfilControl = this.formUsuario.get('perfil');

    if (this.disabledEmail()) {
      emailControl?.disable({ emitEvent: false });
      if (this.isCadastro) {
        emailControl?.setValue(emailControl.value, { emitEvent: false });
      } else {
        emailControl?.setValue(this.usuario.email, { emitEvent: false });
      }
    } else {
      emailControl?.enable({ emitEvent: false });
    }

    if (this.disabledNome()) {
      nomeControl?.disable({ emitEvent: false });
      nomeControl?.setValue(this.usuario.nome, { emitEvent: false });
    } else {
      nomeControl?.enable({ emitEvent: false });
    }

    if (this.isUsuarioAd){
      if (!this.isCadastro) {
        cpfControl?.disable({ emitEvent: false });
        cpfControl?.setValue(this.usuario.cpf, { emitEvent: false });
      } else {
        cpfControl?.enable({ emitEvent: false });
      }
    } else {
      if (!this.isCadastro) {
        cpfControl?.disable({ emitEvent: false });
      } else {
        cpfControl?.enable({ emitEvent: false });
      }
    }

    //provisoria verificação por perfil master
    if (this.usuarioLogado.perfis == 7 || this.isCadastro) {
      perfilControl?.enable({ emitEvent: false });
    } else {
      perfilControl?.disable({ emitEvent: false });
      perfilControl?.setValue(this.usuario.perfil, { emitEvent: false });
    }
  }

  protected configurarUsuarioFormBuilder() {
    this.formUsuario.get('email')?.patchValue(this.usuario.email);
    this.formUsuario.get('nome')?.patchValue(this.usuario.nome);
    this.formUsuario.get('perfil')?.patchValue(this.usuario.perfil);
    this.formUsuario.get('setor')?.patchValue(this.usuario.setorDTO);
    this.formUsuario.get('telefone')?.patchValue(this.usuario.telefone);
    this.formUsuario.get('cpf')?.patchValue(this.usuario.cpf);

    this.atualizarCamposDesabilitados()
  }

  resetarAd() {
    this.usuarios = [];
    this.usuario = new Usuario();
    this.imgUsuario = undefined;
    this.isUsuarioAd = false;
    this.buscouAd = false;
    this.formUsuario.reset();

    this.formUsuario = this.fb.group({
      email: ['', [Validators.required, Validators.minLength(3), Validators.email]],
      nome: ['', [Validators.required, Validators.minLength(3)]],
      perfil: [null, [Validators.required]],
      setor: [null, [Validators.required]],
      telefone: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      cpf: ['', [Validators.required, MethodsUtils.validarCPFControl()]],
    });

    this.atualizarCamposDesabilitados();
  }

  verificarErrorEmailForm() {
    const emailControl = this.formUsuario.get('email');
    if (emailControl && (emailControl.touched || emailControl.dirty)) { return emailControl.invalid; }
    return false;
  }

  buscarPerfis() {
    this.perfilService.buscarPerfilSelectDoGrupo(this.authService.getUsuarioLogado().grupo).subscribe({
      next: res => this.perfis = res
    });
  }

  buscarSetores() {
    this.setorService.buscarSetoresSelect().subscribe({
      next: res => this.setores = res
    });
  }

  selecionarFotoUsuario(event: any) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target?.files[0]);
    reader.onload = () => {
      if(reader.result) {
        this.imgUsuario = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
        this.usuario.imgBase64 = reader.result.toString().split(';base64,')[1];
        this.usuario.extensaoImg = reader.result.toString().split(';base64,')[0].split('/')[1];
      }
    };
  }

  buscarUsuarioPorEmail() {
    this.usuarioService.buscarUsuariosPorEmail(this.usuario.email!).subscribe({
      next: res => res.length > 0 ? this.usuario = res[0] : null
    });
  }

  buscarUsuarioPorAD() {
    this.usuarioService.buscarUsuarioPeloAdEGrupo(this.usuario.email!).subscribe({
      next: res => res.length > 0 ? this.usuario = res[0] : null
    });
  }

  modificarEmail(event: string) {
    this.usuario.email = event;
    if(event.includes('@')) {
      this.buscarUsuarioPorEmail();
    } else if(event.includes('.')) {
      this.buscarUsuarioPorAD();
    }
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

  prepararObj(){
    const formValue = this.formUsuario.value;
    const formControl = this.formUsuario.controls;
    this.usuario.email = formControl['email'].value != undefined ? formControl['email'].value : this.usuario.email;
    this.usuario.nome = formValue.nome != undefined ? formValue.nome : this.usuario.nome;
    this.usuario.perfil = formValue.perfil != undefined ? formValue.perfil : this.usuario.perfil;
    this.usuario.setorDTO = formValue.setor != undefined ? formValue.setor : this.usuario.setorDTO;
    this.usuario.cpf = formValue.cpf != undefined ? formValue.cpf : this.usuario.cpf;
    this.usuario.telefone = formValue.telefone != undefined ? formValue.telefone : this.usuario.telefone;
    this.validarCamposUtilizados()
  }

  salvar() {
    if (this.salvando) { return; }
    this.prepararObj();
  }

  validarCamposUtilizados(){
    let podeAvancar = true;
    const emailControl = this.formUsuario.get('email');
    const cpfControl = this.formUsuario.get('cpf');
    this.salvando = true;
    this.usuarioService.validateUsuario(this.usuario).subscribe({
      next: res => {
        if (res) {
          if (res.existsCpf) {
            cpfControl?.setErrors({ 'existsCpf': true });
            podeAvancar = false;
          }
          if (res.existsEmail) {
            emailControl?.setErrors({ 'existsEmail': true });
            podeAvancar = false;
          }
          if (podeAvancar) {
            this.salvarUsuario();
          } else {
            this.salvando = false;
          }
        } else {
          this.salvando = false;
        }
      },
      error: () => this.salvando = false
    })
  }

  salvarUsuario() {
    this.usuarioService.salvarUsuario(this.usuario).subscribe({
      next: () => {
        this.msgService.msgSucesso('Usuário salvo com sucesso.');
        this.dialog.close(this.usuario);
      },
      error: () => this.salvando = false
    });
  }

  cancelar() {
    if (this.salvando) { return; }
    this.dialog.close();
  }
}
